import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { useDeviceContext } from 'pages/Unitlookup/stores/TelematicsDevice/TelematicsDeviceProvider';
import { useAnalytics } from 'components/analytics/analytics';
import { AnalyticsEvents } from 'components/analytics/analyticsEvents';
import { IOktaContext } from "@okta/okta-react/bundles/types/OktaContext";
import { withOktaAuth } from "@okta/okta-react";
import { LegacyTelematicsDeviceApi } from "../../stores/LegacyTelematicsDevice/LegacyTelematicsDeviceApi";
import { TUSpinnerProgress } from "components/TUSpinnerProgress"

export const FirmwareUpdateButton: React.FC<IOktaContext> = props => {
  const deviceContext = useDeviceContext();
  const analytics = useAnalytics();

  const [confirmChange, setConfirmChange] = React.useState(false);

  const [showProgress, setShowProgress] = React.useState(false);
  const [wasSuccess, setWasSuccess] = React.useState(false);
  const [wasError, setWasError] = React.useState(false);

  function showConfirm() {
    setConfirmChange(true);
    setWasSuccess(false);
    setWasError(false);
  }

  function handleCancel() {
    setConfirmChange(false);
    setShowProgress(false);
  }

  function handleConfirm() {
    analytics.traceEvent(
        Promise.all([updateFirmware(deviceContext.identity.serialNumber), setConfirmChange(false)]),
        AnalyticsEvents.UpdateFirmware,
        {
          serialNumber: deviceContext.identity.serialNumber
        }
    );
  }

  const updateFirmware = (serialNumber: string) => {
    setShowProgress(true);
    return LegacyTelematicsDeviceApi.firmwareUpdate(
        props.authState?.accessToken,
        serialNumber
      )
      .then(() => {
        deviceContext.reloadState();
        setWasSuccess(true);
      })
      .catch((ex) => {
        setWasError(true);
      }
    );
  };

  return (
      <>
        <Button
          onClick={showConfirm}
          variant="contained"
          size="large"
          color="primary">
          Firmware update
        </Button>

        <TUSpinnerProgress
            open={showProgress}
            onClose={handleCancel}
            success={wasSuccess}
            error={wasError}
            successText="Firmware update request was sent successfully"
            errorText="There was an error while sending firmware update request"
        />

        <Dialog
            open={confirmChange && !showProgress}
            onClose={handleCancel}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
          <DialogTitle id="dialog-title">{`Are you sure you want to update firmware?`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="dialog-description">
              The firmware update process might take some time (several minutes) to complete.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
                variant="contained"
                size="large"
                color="primary"
                onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
                variant="contained"
                size="large"
                color="primary"
                onClick={handleConfirm}
                autoFocus
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </>
  );
};

export default withOktaAuth(FirmwareUpdateButton);
